import { FC } from 'react';
import { styled } from '@mui/material/styles';
import clsx from 'clsx';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';

import './SCUIGridToolbar.scss';

const PREFIX = 'SCUIGridToolbar';

const toolbarClasses = {
    root: `${PREFIX}-root`,
    highlight: `${PREFIX}-highlight`,
    title: `${PREFIX}-title`,
};

const StyledToolbar = styled(Toolbar)(() => ({}));

interface IProps {
    numSelected: number;
    headerText: string;
}

export const SCUIGridToolbar: FC<IProps> = ({ numSelected, headerText }) => {
    return (
        <StyledToolbar
            className={clsx(toolbarClasses.root, {
                [toolbarClasses.highlight]: numSelected > 0,
            })}
        >
            {numSelected > 0 ? (
                <Typography className={toolbarClasses.title} color="inherit" variant="subtitle1" component={'div'}>
                    {numSelected} adet seçildi
                </Typography>
            ) : (
                <Typography className={toolbarClasses.title} variant="h6" id="tableTitle" component="div">
                    {headerText}
                </Typography>
            )}
        </StyledToolbar>
    );
};
